import anime from 'animejs';

document.addEventListener('DOMContentLoaded', () => {
	const els = document.querySelectorAll<HTMLElement>('[data-count-from]');
	els.forEach((el) => {
		const from = Number(el.getAttribute('data-count-from'));
		const to = Number(el.innerText);

		if (isNaN(from) || isNaN(to)) return;

		el.innerText = String(from);
		el.style.fontVariantNumeric = 'tabular-nums';
		el.style.letterSpacing = '-0.02em';

		const observer = new IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) {
					observer.unobserve(el);

					anime({
						targets: el,
						innerText: [from, to],
						round: 1,
						duration: 6000,
						easing: 'easeOutQuad',
					});
				}
			},
			{
				threshold: 1,
				rootMargin: '-20px',
			},
		);

		observer.observe(el);
	});
});
